// extracted by mini-css-extract-plugin
module.exports = {"base":"confirmCancelButtonGroup_base__2uRTZ"};